import { render, staticRenderFns } from "./addSelfDrinks.vue?vue&type=template&id=2dfbe3c0&"
import script from "./addSelfDrinks.vue?vue&type=script&lang=js&"
export * from "./addSelfDrinks.vue?vue&type=script&lang=js&"
import style0 from "./addSelfDrinks.vue?vue&type=style&index=0&id=2dfbe3c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports